<template>
  <div class="index">
    <div class="step-2">
      <!-- <el-button class="next-btn" :loading="btnLoading" type="success"  @click="next2">下一步</el-button> -->
      <el-row class="typebox" style="">
        <el-col :span="8" style="text-align: center">
          <el-radio v-model="$store.state.stepTwoShowState" label="portrait">纵向模板{{ $store.state.stepTwoShowStat }}
          </el-radio>
          <el-tooltip class='mytooltip' content="更适用于移动端查看" placement="bottom" effect="light" style="margin-left: -30px">
            <el-button type="text" style='margin:0;padding:0px;line-height:0'><i class="el-icon-info" style="color: #6F7276"></i></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="8" style="text-align: center">
          <el-radio v-model="$store.state.stepTwoShowState" label="landscape">横向模板</el-radio>
          <el-tooltip content="更适用于电脑端浏览器查看" placement="bottom" effect="light" style="margin-left: -30px">
            <el-button type="text" style='margin:0;padding:0px;line-height:0'><i class="el-icon-info" style="color: #6F7276"></i></el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="8" style="text-align: center">
          <el-radio v-model="$store.state.stepTwoShowState" label="customize">自定义模板</el-radio>
          <el-tooltip content="更适用于电脑端邮箱查看" placement="bottom" effect="light" style="margin-left: -30px">
            <el-button type="text" style='margin:0;padding:0px;line-height:0'><i class="el-icon-info" style="color: #6F7276"></i></el-button>
          </el-tooltip>
        </el-col>
      </el-row>

      <!-- 纵向模板 -->
      <el-row v-if="$store.state.stepTwoShowState == 'portrait'">
        <el-col :span="24" style="background: #fff;  ">
          <div class="portraitedit-container">
            <img src="@/assets/phonebottom.png" alt />
            <p class="all-select">
              <span v-if="isShow" class="select-item" @click="isShowSelect">设置可见项</span>
              <span v-show="!isShow">共选中<span class="select-item">{{selectedItem.length}}</span>项</span>
            </p>
            <div class="portrait-container">
              <div class="phonein">
                <table ref="table">
                  <thead>
                    <tr>
                      <td colspan="2" style="
                          font-size: 12px;
                          font-family: PingFangSC-Medium, PingFang SC;
                          font-weight: 500;
                          color: #ffffff;
                          line-height: 17px;
                        ">
                        {{ orgInfo.orgName }}</br>{{$store.state.responeList.query.salaryType}}明细表({{
                          new Date($store.state.stepOne.value2).getFullYear() +
                          '年' +
                          (new Date($store.state.stepOne.value2).getMonth() + 1) +
                          '月'
                        }})
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in $store.state.responeList.headers">
                      <td class='item-checkbox' v-if="!isShow">
                        <el-checkbox
                          :value="isChecked(item)"
                          @change="setSelect(item)"
                        ></el-checkbox>
                      </td>
                      <td class='nameTd'>{{ item.header.replace(/\\"/g, '"') }}</td>
                      <td class='itemTd' v-if="isShow">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 横向模板 -->
      <el-row v-if="$store.state.stepTwoShowState == 'landscape'">
        <el-col :span="24">
          <div class="landscapeedit-container" style="height: 67vh">
            <div class="landscapeeditTitle">
              {{ orgInfo.orgName }}{{$store.state.responeList.query.salaryType}}明细表({{
                new Date($store.state.stepOne.value2).getFullYear() +
                '年' +
                (new Date($store.state.stepOne.value2).getMonth() + 1) +
                '月'
              }})
              <p class="all-select row">
                <span v-if="isShow" class="select-item" @click="isShowSelect">设置可见项</span>
                <span v-show="!isShow">共选中<span class="select-item">{{selectedItem.length}}</span>项</span>
              </p>
            </div>
          
            <div class="landscape-container">
              <table ref="table">
                <thead>
                  <tr>
                    <td v-for="item in $store.state.responeList.headers">
                      <span class='item-checkbox' v-if="!isShow">
                        <el-checkbox
                          :value="isChecked(item)"
                          @change="setSelect(item)"
                        ></el-checkbox>
                      </span>
                      {{ item.header.replace(/\\"/g, '"') }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="item in $store.state.responeList.headers"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 自定义模板 -->
      <el-row :gutter="20" v-if="$store.state.stepTwoShowState == 'customize'" style="background: #fff; height: 67vh; padding-top: 10px;margin:0!important">
        <el-col :span="5">
          <p class="l-border-title">系统已解析出工资条类别</p>
          <div class="btn-container">
            <div @click="insertDate($store.state.stepOne)" class="header-btn">
              发薪日期
            </div>
            <div @click="insertDefault(orgInfo.orgName )" class="header-btn">
              企业名称
            </div>
            <div @click="insertImg(userInfo.logoUrl)" class="header-btn">
              公司logo
            </div>
            <div @click="insertContent(item.header)" class="header-btn" v-for="(item, index) in $store.state.responeList.headers" :key="index" :title="item.header">
              {{
                item.header.length > 10
                  ? item.header.replace(/\\"/g, '"') .slice(0, 10) + '..'
                  : item.header
              }}
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="edit-container">
            <p class="l-border-title">
              编辑工资条
              <span style="font-size: 12px; color: #67c23a">提示:当光标在编辑器内的某处时，点击左边的工资条类别，发送后对应数据就将会展示在该处</span>
            </p>
            <edit ref="edit" v-model="$store.state.responeList.query.content" :height="'40vh'"></edit>
          </div>
        </el-col>
        <el-col :span="5">
          <p class="l-border-title">默认模板</p>
          <p>
            <span style="font-size: 12px; color: #67c23a; font-weight: 600 !important">提示:首次使用模版时，需手动选中左侧工资条类别到模版展示，下次可重复使用</span>
          </p>
          <el-row>
            <div class="default-tpl">
              <div v-for="i in userAuth.defaultTemplate * 1">
                <img @click="hanleSelectPic(templateList[i - 1])" v-if="templateList[i - 1]" 
                style="width: 100%; height: 90px" :src="templateList[i - 1].picUrl" alt />
              </div>
            </div>
          </el-row>
        </el-col>
        <el-col :span="5">
          <p class="l-border-title" style="margin-top: 10px">我的模板</p>
          <el-row  :style="{'overflow-y':'auto','height': (userAuth.defaultTemplate>3?'calc(100vh - 570px)':'calc(100vh - 480px)')}" >
            <!-- <div class="default-tpl">
              <div v-for="i in UserTemplateList.length" :key="i" :class="[UserTemplateList[i - 1] || {}.id ? 'has' : '']">
                <img @click="hanleSelectPicMy(UserTemplateList[i - 1])" v-if="UserTemplateList[i - 1]" style="width: 100%; height: 100px" :src="UserTemplateList[i - 1].picUrl" alt />
                <div v-show="UserTemplateList[i - 1] || {}.id" class="toast">
                  <el-tooltip class="i-tips" effect="light" placement="bottom" content="删除">
                    <i style="margin-left: 10px" class="hover-i el-icon-delete" @click="handleDel(UserTemplateList[i - 1])"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>  -->
            <div class="box">
                <div class="box-item" v-for="(temp,i) in UserTemplateList" :key="i" v-show="i<=2" >
                  <img class="imgs"   @click="hanleSelectPicMy(temp)" style="width: 100%; height: 90px"  :src="temp.picUrl" />
                  <div  class="box1 ">
                      <i  style="margin-left: 10px" class="delete-icon hover-i el-icon-delete" @click="handleDel(temp)"></i>
                  </div>
                  <div class="wrapper">删除</div>
                </div>
              </div>

              <div class="box" v-show = 'UserTemplateList.length>3'>
                <div class="box-item" v-for="(temp,i) in UserTemplateList" :key="i"  v-show="i>2&&i<6">
                  <img class="imgs"  @click="hanleSelectPicMy(temp)" style="width: 100%; height: 90px"  
                        :src="temp.picUrl" />
                  <div  class="box1 ">
                      <i  style="margin-left: 10px" class="delete-icon hover-i el-icon-delete" @click="handleDel(temp)"></i>
                  </div>
                  <div class="wrapper">删除</div>
                </div>
              </div>

              <div class="box" v-show = 'UserTemplateList.length>6'>
                <div class="box-item" v-for="(temp,i) in UserTemplateList" :key="i"  v-show="i>5">
                  <img class="imgs"  @click="hanleSelectPicMy(temp)" style="width: 100%; height: 90px"  
                        :src="temp.picUrl" />
                  <div  class="box1 ">
                      <i  style="margin-left: 10px" class="delete-icon hover-i el-icon-delete" @click="handleDel(temp)"></i>
                  </div>
                  <div class="wrapper">删除</div>
                </div>
              </div>

              
          </el-row>
        </el-col>
      </el-row>
      <el-dialog title="消息" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false">
        <p style="line-height: 40px">您的模版已满，请选择替换的模版！</p>
        <div class="default-tpl" style="min-height: 120px">
          <div v-for="i in UserTemplateList.length" :key="i" :class="[UserTemplateList[i - 1] || {}.id ? 'has' : '']" style="padding: 0 10px; position: relative">
            <span @click="
                selectImgHandle(
                  UserTemplateList[i - 1],
                  i,
                  UserTemplateList.length
                )
              " :ref="'selectimg' + i" class="selectStyle" :class="selectId == 1 ? 'selectImg' : ''"></span>
            <img v-if="UserTemplateList[i - 1]" style="width: 100%; height: 100%; display: block; margin: 0 auto" :src="UserTemplateList[i - 1].picUrl" alt />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="medium" round>&nbsp;&nbsp; 取 消 &nbsp;&nbsp;</el-button>
          <el-button type="primary" @click="enterSelImg" size="medium" round>&nbsp;&nbsp; 确 定 &nbsp;&nbsp;</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import edit from "@/components/edit";
import { constants } from "crypto";
import Cookie from "js-cookie";
import { next } from "@/api/setUp.js";

export default {
  name: "step2",
  props: ["selectedItems"],
  components: {
    edit,
  },
  data() {
    return {
      rickText: "",
      templateList: [],
      UserTemplateList: [],
      userInfo: "",
      userAuth: {},
      dialogVisible: false,
      selectId: "",
      orgInfo: [],
      selectedItem: [],
      isShow: true,
      btnLoading: false,
    };
  },
  methods: {
    // next2(){
    //   this.$emit('next2')
    // },
    // btnLoadings(val){
    //   this.btnLoading = val;
    // },
    isShowSelect() {
      this.isShow = !this.isShow;
    },
    // 判断是否全部选中
    isAllChecked() {
      return this.$store.state.responeList.headers.length ==
        this.selectedItem.length && this.selectedItem.length > 0
        ? true
        : false;
    },
    // 设置全部选中
    setAllSelect() {
      if (this.$store.state.selectedItem.length > 0) {
        this.selectedItem = [...this.$store.state.selectedItem];
        this.isShowSelect();
      } else {
        this.isAllChecked()
          ? (this.selectedItem = [])
          : (this.selectedItem = [...this.$store.state.responeList.headers]);
      }
    },
    // 设置单选
    setSelect(_item) {
      if (this.isChecked(_item)) {
        this.selectedItem.splice(
          this.selectedItem.findIndex((item) => item.header == _item.header),
          1
        );
      } else {
        this.selectedItem.push(_item);
      }
      this.$store.commit("setGZT", this.selectedItem);
    },
    // 判断是否选中
    isChecked(item) {
      const flag = this.selectedItem.some((_item) => {
        return _item.header == item.header;
      });
      return flag;
    },
    async handleDel(i) {
      this.$confirm("将会删除选择模板，是否确认？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(() => {
          this.$http
            .delete(`/salary-service/customer/template/${i.id}/delete`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$store.commit("delUserTemplateList", i.id);
                this.$notify({
                  title: "成功",
                  message: "模板删除成功",
                  type: "success",
                });
                this.getUserTemplate();
                // this.getDefaultTemplate()
              } else {
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    insertDate(state) {
      window.tinymce.activeEditor.execCommand(
        "mceInsertContent",
        false,
        `『发薪日期』`
      );
    },
    insertImg(url) {
      if (!url) {
        return this.$notify({
          message: "未上传公司logo",
          type: "warning",
        });
      }
      window.tinymce.activeEditor.execCommand(
        "mceInsertContent",
        false,
        `<img src="${this.$http.defaults.baseURL}/authority-center/open/showImg?path=${url}"></img>`
      );
    },
    insertDefault(header) {
      window.tinymce.activeEditor.execCommand(
        "mceInsertContent",
        false,
        `『企业名称』`
      );
    },
    insertContent(header) {
      window.tinymce.activeEditor.execCommand(
        "mceInsertContent",
        false,
        `『${header.replace(/\\"/g, '"')}』`
      );
    },
    async getDefaultTemplate() {
      let res = await this.$http.get("/salary-service/customer/templatePage");
      this.templateList = res.data;
      console.log(res, "系统模板");
      this.$emit("changeTempState", true);
    },
    async getUserTemplate(num) {
      let res1 = await this.$http.get(
        `/salary-service/customer/customerTemplate`
      );
      console.log(res1, "客户模板");
      // this.UserTemplateList = res1.data.slice(-num)
      this.UserTemplateList = res1.data.slice(-this.userAuth.customTemplate);
      console.log(
        this.UserTemplateList,
        "888888",
        this.userAuth.customTemplate
      );
      console.log(this.UserTemplateList, "ccc");
      this.selectId = res1.data[0];
      this.$store.commit("getuserTplNum", res1.data.length);
      this.$store.commit("getUserTemplateList", res1.data);
    },

    // 点击我的模板
    async hanleSelectPicMy(item) {
      console.log(item.id, "点击我的模板ID");

      let res = await this.$http.get(
        `salary-service/customer/template/${item.id}`
      );
      this.$store.state.responeList.query.templateId = item.id;
      this.$store.state.responeList.query.content = res.data.content;
      // this.$store.commit('getContent', res.data)
      // console.log(res.data)
      // this.$store.commit('setpTwoStr', res.data.content)
    },
    // 点击默认模板
    async hanleSelectPic(item) {
      let res = await this.$http.get(
        `salary-service/customer/template/${item.id}`
      );
      this.$store.state.responeList.query.templateId = "";
      this.$store.state.responeList.query.content = res.data.content;
      // this.$store.commit('getContent', res.data)
      // console.log(res.data)
      // this.$store.commit('setpTwoStr', res.data.content)
    },
    async getUserAuth() {
      let res = await this.$http.get(
        `/salary-service/customer/getPackageServiceByCustomer`
      );
      this.$store.commit("getUserAuth", res.data);
      this.$store.commit("changeCustomTemplate", res.data.customTemplate);
      this.$store.commit("changeDefaultTemplate", res.data.defaultTemplate);
      this.userAuth = res.data;

      console.log(this.userAuth, "套餐模板限制");
      console.log(this.userAuth.defaultTemplate, "系统模板个数");
      console.log(this.userAuth.customTemplate, "客户模板个数");
      this.getUserTemplate(this.userAuth.customTemplate);
    },
    saveTaplate() {},
    showTemplate() {
      this.dialogVisible = true;
    },
    // 点击替换模板
    selectImgHandle(i, index, all) {
      console.log("选择替换的模板");
      this.$store.state.responeList.query.templateId = i.id;
      this.selectId = i;
      console.log(i);
      for (let j = 1; j <= all; j++) {
        this.$refs["selectimg" + j][0].classList.remove("selectImg");
      }
      this.$refs["selectimg" + index][0].classList.add("selectImg");
    },
    // 模板替换确定
    async enterSelImg() {
      if (this.$store.state.responeList.query.templateId == "") {
        this.$notify({
          title: "失败",
          message: "请先选择需要替换的模板",
          type: "warning",
        });
        return 0;
      }
      // this.$store.state.responeList.query.content
      let data = {
        list: this.$store.state.responeList.data,
        query: this.$store.state.responeList.query,
      };
      let { data: res } = await next(data);
      if (res.code == 200) {
        this.$notify({
          title: "成功",
          message: "替换成功",
          type: "success",
        });
        this.$store.state.responeList.query.templateId = res.data.templateId;
        this.getUserTemplate();
      } else {
        this.$notify({
          title: "失败",
          message: "替换失败" || res.msg,
          type: "fail",
        });
      }
      this.dialogVisible = false;
      return 0;
      // this.$http
      //   .post('salary-service/customer/update1', {
      //     id: this.selectId.id,
      //     content: this.$store.state.stepTwo.content,
      //   })
      //   .then((res) => {
      //     if (res) {
      //       // this.$store.commit("delUserTemplateList", this.selectId.id);
      //       this.$store.commit('changeIsmodify', true)
      //       this.dialogVisible = false
      //       this.$notify({
      //         title: '成功',
      //         message: '替换成功',
      //         type: 'success',
      //       })
      //       // this.getUserTemplate();
      //       this.getDefaultTemplate()
      //     } else {
      //       this.$notify({
      //         title: '失败',
      //         message: '替换失败功',
      //         type: 'fail',
      //       })
      //     }
      //   })
    },
    getUserInfo() {
      this.$http.get("authority-center/common/user/info").then((res) => {
        this.posId = res.data.orgId;
        this.orgInfo = res.data;
        console.log(this.orgInfo, "c_++++");
        this.$store.commit("getorgId", this.orgInfo.orgId);
        this.$http.get(`authority-center/org/${res.data.orgId}`).then((res) => {
          this.userInfo = res.data;
          console.log(res.data, "__-__");
        });
      });
    },
  },
  mounted() {
    // this.userInfo = Cookie.get("userInfo")
    //   ? JSON.parse(Cookie.get("userInfo"))
    //   : "";
    this.getUserInfo();
    this.getDefaultTemplate();
    // this.getUserTemplate();
    this.getUserAuth();
    this.setAllSelect();
  },
  updated() {
    this.rickText = this.$store.state.stepTwo.content;
  },
};
</script>

<style lang="less" scoped>
.has {
  &:hover {
    .toast {
      bottom: 0px;
      transition: bottom 0.5s;
    }
  }
}
.default-tpl {
  > div {
    position: relative;
    overflow: hidden;
    .toast {
      position: absolute;
      transition: bottom 0.5s;
      padding: 0px 5px;
      width: calc(100% - 10px);
      bottom: -50px;
      height: 50px;
      left: 5px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.6);
      i {
        color: #fff;
        margin-left: 0 !important;
      }
    }
  }
}
.default-tpl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  > div {
    margin-top: 3px;
    width: 30%;
    height: 90px;
    box-sizing: border-box;
    img {
      border-radius: 4px;
      border: 1px solid rgba(224, 234, 241, 1);
      &:hover {
        border: 1px solid rgba(59, 196, 146, 1);
      }
    }
  }
}
.btn-container {
  height: 52vh;
  overflow-y: scroll;
}

.index {
  padding: 0 10px;
  height: calc(100vh - 143px);
  background: #f3f5f7;
  .typebox {
    width: 60%;
    margin: 0 auto;
    height: 6vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  min-height: 287px;
  .header-btn {
    margin-top: 8px;
    text-align: center;
    line-height: 36px;
    width: 95%;
    height: 36px;
    cursor: pointer;
    background: rgba(255, 255, 255, 1);
    border-radius: 24px;
    border: 1px solid rgba(224, 234, 241, 1);
    &:hover {
      background: rgba(59, 196, 146, 1);
      color: #fff;
    }
  }
  .template-container {
    height: 100px;
    box-sizing: border-box;
    img {
      border-radius: 4px;
      border: 1px solid rgba(224, 234, 241, 1);
      &:hover {
        border: 1px solid rgba(59, 196, 146, 1);
      }
    }
  }
}
.portraitedit-container {
  height: 74vh !important;
  width: 42vh !important;
  margin: 0 auto;
  padding: 5vh 0.6vw 0 0.7vw;
  // background-color: #fff;
  border-radius: 8px;
  background: url("../assets/phone.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  // padding-bottom: ;
  img {
    width: calc(100% - 1.1vw);
    height: 8vh;
    position: absolute;
    bottom: 1vh;
    left: 0;
    margin: 0 0.6vw 0 0.7vw;
  }
  // .portrait-container::-webkit-scrollbar {
  //   display: none;
  // }
  .portrait-container {
    height: 61vh !important;
    overflow-y: auto;
    margin: 0 auto;
    padding-left: 5px;
    .phonein {
      table {
        width: 100%;
        border-collapse: collapse;
        thead {
          background-color: #3bc492;
          text-align: center;
          color: #fff;
          border-radius: 8px 8px 0px 0px !important;
          td {
            padding: 8px 0 !important;
            font-size: 12px !important;
            line-height: 35px;
          }
        }
        .nameTd {
          width: 40%;
          text-align: left;
          padding-left: 15px;
        }
        .itemTd {
          text-align: right;
          padding-right: 15px;
        }
        tbody {
          tr {
            box-shadow: inset 0px 0px 1px 0px #c4cdd3;
            td {
              width: 50%;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 450;
              color: #2c2d3a;
              line-height: 20px;
              padding: 10px 0;
            }
            .item-checkbox {
              width: 5%;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
.landscapeedit-container {
  overflow-y: auto;
  width: 100%;
  margin: 0 auto;
  padding: 27px;
  background-color: #fff;
  border-radius: 8px;
  .landscapeeditTitle {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 550;
    color: #000000;
    line-height: 22px;
    text-align: center;
    margin-bottom: 27px;
    position: relative;
  }
}
.landscape-container {
  overflow-x: auto;
  padding: 15px 0;
  > table {
    border-collapse: collapse;
    height: 100px;
    width: 200%;
    td {
      border: 1px solid #9e9c9c;
      text-align: center;
      min-width: 100px;
      height: 50px;
    }

    thead {
      tr {
        height: 50px;
        line-height: 50px;
        background-color: #3bc492;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
}
.edit-container {
  overflow-y: auto;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  padding: 0 10px;
}
.saveTaplate {
  float: right;
  font-size: 14px;
  color: #3bc492;
  cursor: pointer;
}
.selectStyle {
  position: absolute;
  top: 0;
  left: 10px;
  right: 10px;
  bottom: 0px;
  display: block;
  border-radius: 2px;
  font-size: 18px;
}
.selectImg {
  border: 2px solid #3bc4928c !important;
  background: url("../assets/success-filling.png") no-repeat center
    rgba(59, 196, 146, 0.6);
  background-size: 45%;
}
.fc {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .el-tooltip__popper {
  line-height: 1 !important;
}
.box {
  height: 100px;
  display: flex;
  align-items: flex-end;
  // overflow: hidden;
  justify-content: space-between;
}
.box-item {
  position: relative;
  margin-top: 3px;
  width: 30%;
  height: 100px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.imgs {
  border: 1px solid #e0eaf1;
}
.box1 {
  width: 40px;
  height: 0px;
  transition: height 0.5s;
  position: absolute;
  padding: 0px 5px;
  width: calc(100% - 10px);
  bottom: 9px;
  left: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  i {
    color: #fff;
    margin-left: 0 !important;
  }
}
.delete-icon {
  display: none;
}
.wrapper {
  position: absolute;
  margin: 20px auto;
  border: 1px solid #000;
  border-radius: 3px;
  text-align: center;
  top: 81px;
  left: 0;
  right: 0;
  margin: auto;
  display: none;
  font-size: 12px;
  padding: 6px;
  background: #fff;
  max-width: 47px;
  z-index: 999;
}
.wrapper:before {
  content: "";
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-bottom-color: #000;
  position: absolute;
  top: 0;
  left: 18px;
  margin-top: -11px;
}
.wrapper:after {
  content: "";
  width: 0;
  height: 0;
  border: 7px solid transparent;
  border-bottom-color: #fff;
  position: absolute;
  top: 14px;
  left: 16px;
  margin-top: -26px;
}

.box-item:hover .box1 {
  height: 50px;
}
.box-item:hover .wrapper,
.box-item:hover .delete-icon {
  display: block;
}
.all-select {
  position: absolute;
  cursor: pointer;
  right: -80px;
  color: rgba(0, 0, 0, 0.6);
  .select-item {
    color: #3bc492;
  }
}
.all-select.row span {
  font-size: 14px;
  font-weight: normal;
}
.landscapeeditTitle .all-select {
  right: 0px;
  top: 0;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: white;
}

.landscape-container /deep/ .item-checkbox .el-checkbox .el-checkbox__inner {
  background-color: #3bc492;
  border: 1px solid #fff;
}

.next-btn {
  position: absolute;
  bottom: 35px;
  right: 80px;
  z-index: 100;
}
.step-2 {
  background: #fff;
  height: calc(100vh - 134px);
  margin: 10px 0;
  border-radius: 8px;
}
</style>
